<template>

  <!-- --------------------------------------------------------- -->
  <!-- ---------------- Page Header ----------------------------- -->
  <!-- --------------------------------------------------------- -->

  <div class="mainPageDiv">

    <div class="pageHeader">
      Arming Authorities
    </div>

    <span class="subHeaderFont">Create New Arming Authority:</span>

    <div @click="handleCreateRecord" 
         class="material-icons forIconNewRecord text-success" 
         data-tooltip="tooltip"
         title="Create a new Arming Authority">
      add_card
    </div>

    <div class="radioheaderadjustment radioFirstLeftMargin">
      <input type="radio" 
             @click="handleActiveRadioClick" 
             id="radioActiveButtonID" 
             name="armingAuthState"
             aria-label="Show Active Users"
             checked />

      <label class="lableMargin subHeaderFont" for="setup">Active</label>
    </div>

    <div class="radioheaderadjustment radioOtherLeftMargin ">
      <input type="radio" 
             @click="handleAllRadioClick" 
             id="radioAllButtonID" 
             aria-label="Show All Users"
             name="armingAuthState" />

      <label class="lableMargin subHeaderFont" for="setup">All</label>
    </div>

    <!-- --------------------------------------------------------- -->
    <!-- ---------------- Data Grid ------------------------------ -->
    <!-- --------------------------------------------------------- -->

    <ApplicationGrid 
             :GridData="gridTime" 
             RowsPerPageText="Arming Authority Records"
             SearchText="Search Arming Authority Records:"
             :EnablePaging="true" 
             :EnableSearching="true" 
             :EnableSorting="true"
             :HeaderArrays="headerArrays" 
             :LeftRightSlots="leftRightSlots"             
             :RowsPerPageArray="rowsPerPageArray" 
             :EnableSettings="false"
             :EnableRecordsInfoDisplay="true">


        <!-- ------------------------------------------------------------------------------- -->
        <!-- -------------- RIGHT Email Verified (rightHeader10/rightData10) --------------- -->
        <!-- ------------------------------------------------------------------------------- -->
  
        <template v-slot:rightHeader10>
          <span class="actionsHeader" >Active</span>
        </template>
  
        <template v-slot:rightData10="slotArgs">
  
          <div class="activeAgency" 
               :id="'Agency1_' + slotArgs.itemArg['agency_ID']" 
               data-tooltip="tooltip" 
               title="Click to toggle Active status">
  
            <input type="checkbox" 
                   :checked="slotArgs.itemArg['isActive']"
                   value="" aria-label="Check this box to make the record active"
                   @click="handleActiveLinkClick(slotArgs)">
  
          </div>
  
        </template>
  
        <!-- ------------------------------------------------------------------------ -->
        <!-- -------------- RIGHT Action (rightHeader11/rightData11) ---------------- -->
        <!-- ------------------------------------------------------------------------ -->
  
        <template v-slot:rightHeader11>
          <span class="actionsHeader" >Edit</span>
        </template>
  
        <template v-slot:rightData11="slotArgs">
  
          <span @click="handleEditRecord(slotArgs)" 
                class="material-icons text-primary editIconSlot"
                data-tooltip="tooltip" 
                title="Edit Record">
            edit
          </span>
  
        </template>

        <!-- ------------------------------------------------------------------------------- -->
        <!-- -------------- SLOT END ------------------------------------------------------- -->
        <!-- ------------------------------------------------------------------------------- -->
             
    </ApplicationGrid>
  </div>

  <!-- ----------------------------------------------------------------------------- -->
  <!-- --------------------------- MODAL Update-Create start ------------------------ -->
  <!-- ------------------------------------------------------------------------------ -->

  <div id="xmodal-main-ID" class="xmodal-container-main">
    <div class="xmodal-container-content">

      <!-- ---------------------------------------------------------------- -->
      <!-- --------------------------- HEADER ----------------------------- -->
      <!-- ---------------------------------------------------------------- -->

      <div class="header-primary headerMainContainer">
        <div style="display: inline-block;">&nbsp;</div>
        <div style="color: white; display: inline-block">{{ modalTitle }}</div>
        <div class="cancelModalX" @click="CloseModalUpdateCreate" style="margin-right: 10px; color: white; display: inline-block; text-align: right; align-items: end;">X</div>
      </div>

      <hr class="xmodal-hr-top" />

      <!-- ---------------------------------------------------------------- -->
      <!-- --------------------------- FORM ------------------------------- -->
      <!-- ---------------------------------------------------------------- -->

      <div class="xmodal-container-form">
        <!-- ------- Record Id -->
        <div v-if="createSelected == false" class="xmodal-content-justify-right xmodal-control-labels"
          data-tooltip="tooltip" title="Database Record ID" id="recID">Record Id</div>
        <div v-if="createSelected == false" class="xmodal-content-justify-left xmodal-textbox-padding">
          <input id="agencyIDTxtBx" v-model="armingauth_ID" type="text" size="9" disabled aria-labelledby="recID"/>
        </div>
        <!-- ------- Agency Name -->
        <div class="xmodal-content-justify-right xmodal-control-labels" data-tooltip="tooltip" title="Arming Authorization Name" id="aaName">
          Arming Authorization Name:<span v-if="nameUndefined || nameNotUnique" class="xmodal-required-asterisk text-danger">*</span>
        </div>
        <div class="xmodal-content-justify-left xmodal-textbox-padding">
          <input id="NameTxtBx" v-model="name" type="text" size="50" aria-labelledby="aaName"/>
        </div>

        <!-- ------- Agency Acronym -->
        <div class="xmodal-content-justify-right xmodal-control-labels" data-tooltip="tooltip" title="Arming Acronym" id="aaAcr">
          Arming Authorization Acronym:<span v-if="acronymUndefined" class="xmodal-required-asterisk text-danger">*</span>
        </div>
        <div class="xmodal-content-justify-left xmodal-textbox-padding">
          <input id="acronymTxtBx" v-model="acronym" type="text" size="20" aria-labelledby="aaAcr"/>
        </div>

        <!-- ------- Active Radio Buttons -->
        <div class="xmodal-content-justify-right xmodal-control-labels" data-tooltip="tooltip"
          title="Arming Authority Acronym">
          Active:<span v-if="activeNotSelected" class="xmodal-required-asterisk text-danger">*</span>
        </div>
        <div class="xmodal-content-justify-left xmodal-textbox-padding">

          <input type="radio" :checked="((active == true) && (createSelected == false))" id="radioActiveID"
            name="activeRadioButtons" class="vertAlignMiddle" />

          <label class="labelAlign" for="radioActiveID">Yes</label>

          <input type="radio" :checked="((active == false) && (createSelected == false))" id="radioInactiveID"
            name="activeRadioButtons" class="vertAlignMiddle radioButtonLeftMargin" />

          <label class="labelAlign" for="radioInactiveID">No</label>

        </div>

        <!-- ------- Arming Authority list -->
        <div v-if="createSelected == false" class="xmodal-content-justify-right xmodal-control-labels"
          data-tooltip="tooltip" title="Arming Authority Acronym">
          Last Updated:<span v-if="armingAuthorityAcronymUndefined"
            class="xmodal-required-asterisk text-danger">*</span>
        </div>
        <div v-if="createSelected == false" class="xmodal-content-justify-left xmodal-textbox-padding">
          <span>{{ updateDate }}</span>
        </div>

      </div>

      <!-- ---------------------------------------------------------------- -->
      <!-- --------------------------- Validation ------------------------- -->
      <!-- ---------------------------------------------------------------- -->

      <hr v-if="validationErrorsFound" class="xmodal-hr-bottom" />
      <div v-if="validationErrorsFound" class="text-danger xmodal-outer-div">Required fields indicated by asterisk(s).
        Make selections for the following:
        <div class="xmodal-inner-div">
          <ul class="xmodal-li-validation">
            <li v-if="nameUndefined"> Arming Authorization Name</li>
            <li v-if="acronymUndefined"> Arming Acronym</li>
            <li v-if="nameNotUnique"> Arming Authorization Name already exists </li>
            <li v-if="activeNotSelected"> Please specify whether or not the Arming Authorization is Active </li>
          </ul>
        </div>
      </div>

      <hr class="xmodal-hr-bottom" />

      <!-- ---------------------------------------------------------------- -->
      <!-- --------------------------- Footer ----------------------------- -->
      <!-- ---------------------------------------------------------------- -->

      <div class="xmodal-footer">
        <button type="button" @click="CloseModalUpdateCreate"
          class="btn-danger">
          Cancel
        </button>
        <button id="xmodal-submit-btn-id" type="button" @click="handleEditClickSubmitBtn"
          class="btn-primary">
          Submit
        </button>
      </div>
    </div>
  </div>

</template>

<script>
import axios from "axios";
import { store } from "../../../store/store.js";
import ApplicationGrid from "../../../components/dataSupport/ApplicationGrid.vue"

export default {
  data() {
    return {
      store,
      acronym: null,
      active: null,
      activeNotSelected: false,
      armingauth_ID: null,
      armingAuthState: 'active',
      createSelected: false,
      gridTime: { grid: null, time: null },
      gridOfNamesOnly: null,
      name: null,
      nameUndefined: false,
      acronymUndefined: false,
      nameNotUnique: false,
      modalTitle: null,
      rowsPerPageArray: [10, 25, 50, 100, 250],
      updateDate: null,
      validationErrorsFound: false,

      headerArrays: [
        { defaultShow: false, rawName: 'armingAuthorityId', displayName: 'Arming Auth ID', hoverText: 'Arming Authorization database primary key' },
        { defaultShow: true, rawName: 'armingAuthorityName', displayName: 'Arming Auth Name', hoverText: 'Arming Authorization Name' },
        { defaultShow: true, rawName: 'armingAuthorityAcronym', displayName: 'Arming Auth Acronym', hoverText: 'Arming Authorization Acronym' },
        { defaultShow: false, rawName: 'isActive', displayName: 'isActive', hoverText: 'Is active flag.' },
        { defaultShow: false, rawName: 'createDate', displayName: 'Create Date', hoverText: 'Create Date' },
        { defaultShow: false, rawName: 'createBy', displayName: 'CreateBy', hoverText: 'Create by user ID' },
        { defaultShow: false, rawName: 'updateDate', displayName: 'Udate Date', hoverText: 'Update Date' },
        { defaultShow: false, rawName: 'updateBy', displayName: 'UpdateBy', hoverText: 'Udate by user ID' },
      ],
  
        //leftHeader0,   ..., leftHeader9
        //rightHeader10, ..., rightHeader19
        leftRightSlots: [
          { slot: 'rightHeader10', enableSorting: true, field: 'isActive'},
          { slot: 'rightHeader11', enableSorting: true, field: '__not_specified__'},
        ],

    };
  },
  created() {

    this.getGridData();

  },
  computed: {
    UserProfileId() {
      return store.authenticatedUser.userProfileId != null 
      ? store.authenticatedUser.userProfileId
      : store.tempUserProfileId;
    }, 
  },
  components: { ApplicationGrid },
  methods: {

    clearValidationFields() {
      this.$data.nameUndefined = false;
      this.$data.acronymUndefined = false;
      this.$data.nameNotUnique = false;
      this.$data.validationErrorsFound = false;
      this.$data.activeNotSelected = false;
    },

    CloseModalUpdateCreate() {
      // console.log("OpenModalFnc()");
      let modalWindow = document.querySelector("#xmodal-main-ID");
      modalWindow.style.display = "none";
    },

    databaseCreateRecored() {
      //Using a flag value such as the following avoids issues with
      //passing blank values in a query string.
      if (this.$data.acronym == null) {
        this.$data.acronym = "__null__";
      } else if (this.$data.acronym.trim().length == 0) {
        this.$data.acronym = "__null__";
      }

      let activeYes = document.querySelector('#radioActiveID');
      let localActive = null;
      if (activeYes.checked) {
        localActive = true;
      } else {
        localActive = false;

      }

      axios
        .post(store.webAPIUrl + "ArmingAuthority/CreateArmingAuth/" +
          this.UserProfileId + '/' +
          this.$data.name + "/" +
          this.$data.acronym + "/" +
          localActive
        )
        .then((response) => response.data)
        .then(() => {
          // console.log(data);
          this.getGridData();
        });
    },

    databaseUpdateRecord() {

      //Using a flag value such as the following avoids issues with
      //passing blank values in a query string.
      if (this.$data.acronym == null) {
        this.$data.acronym = "__null__";
      } else if (this.$data.acronym.trim().length == 0) {
        this.$data.acronym = "__null__";
      }

      let activeYes = document.querySelector('#radioActiveID');
      let localActive = null;
      if (activeYes.checked) {
        localActive = true;
      } else {
        localActive = false;
      }

      // console.log('this.$data.acronym = ', this.$data.acronym);
      // console.log('this.$data.armingauth_ID = ', this.$data.armingauth_ID);
      // console.log('this.$data.name = ', this.$data.name);
      // console.log('localActive = ', localActive);

      axios
        .post(store.webAPIUrl + "ArmingAuthority/UpdateArimingAuth/" +
          this.UserProfileId + '/' +
          this.$data.armingauth_ID + "/" +
          this.$data.name + "/" +
          this.$data.acronym + "/" +
          localActive
        )
        .then((response) => response.data)
        .then(() => {
          // console.log(data);
          this.getGridData();
        });
    },

    //Used to format dates passed to the HTML date control.
    formatDateFnc(value) {
      let monthPart = value.substring(0, 2);
      let dayPart = value.substring(3, 5);
      let yearPart = value.substring(6, value.length);
      return monthPart + '/' + dayPart + '/' + yearPart;
    },

    getGridData() {

      axios
        .get(store.webAPIUrl + "ArmingAuthority/SelArmingAuthorityActiveFlag/" + this.$data.armingAuthState)
        .then((response) => response.data)
        .then((data) => {
          this.$data.gridTime = { grid: data, time: new Date().getTime() };
          //This has to be updated for validation.
          this.getAllNames();
        });
    },

    getAllNames() {
      axios
        .get(store.webAPIUrl + "ArmingAuthority/SelArmAuthNames")
        .then((response) => response.data)
        .then((data) => {
          this.$data.gridOfNamesOnly = data;
          // console.log('this.$data.gridOfNamesOnly = ', this.$data.gridOfNamesOnly);
        });
    },

    //This is called in response to clicking the Active/Inactive links.
    handleActiveLinkClick(args) {

      let armingauthid = args.itemArg["armingAuthorityId"];

      // console.log('args.itemArg["active"] = ', args.itemArg["active"]);
      // console.log('args.itemArg["armingauth_ID"] = ', args.itemArg["armingauth_ID"]);
      // console.log('ctrlControlID = ', ctrlControlID);

      let newActive = false;
      if (args.itemArg["isActive"] == false) {
        newActive = true;
      }

      // console.log('newActive = ', newActive);

      this.UpdateRecordActiveState(armingauthid, newActive);

    },

    handleActiveRadioClick() {
      this.$data.armingAuthState = 'active';

      this.getGridData();
    },

    handleAllRadioClick() {
      this.$data.armingAuthState = 'all';

      this.getGridData();
    },

    //This is called in response to clicking the create div.The dialog
    //modal is opened due to properties set in the edit div. 
    handleCreateRecord() {
      // console.log('-->> handleCreateRecord()');
      this.$data.createSelected = true;
      this.clearValidationFields();

      let modalWindow = document.querySelector("#xmodal-main-ID");
      modalWindow.style.display = "block";

      let yesRadioButton = document.querySelector('#radioActiveID');
      let noRadioButton = document.querySelector('#radioInactiveID');

      yesRadioButton.checked = false;
      noRadioButton.checked = false;

      this.$data.modalTitle = 'Create Arming Authorization Record';

      this.$data.name = null;
      this.$data.acronym = null;

    },

    //This method is called when clicking on the submit button
    //in the update modal.
    handleEditClickSubmitBtn() {

      this.validateFields();

      if (this.$data.validationErrorsFound == false) {

        let modalWindow = document.querySelector("#xmodal-main-ID");
        modalWindow.style.display = "none";

        if (this.$data.createSelected == true) {
          this.databaseCreateRecored();
        } else {
          this.databaseUpdateRecord();
        }
      }

    },

    //This is called in response to clicking the pencil icon for a record. The dialog
    //modal is opened due to properties set in the edit div. 
    handleEditRecord(args) {

      this.$data.createSelected = false;
      this.clearValidationFields();

      //These will be used the modal window.
      this.$data.armingauth_ID = args.itemArg["armingAuthorityId"];
      this.$data.name = (args.itemArg["armingAuthorityName"]).trim();

      this.$data.acronym = (args.itemArg["armingAuthorityAcronym"] != null) ? (args.itemArg["armingAuthorityAcronym"]).trim() : args.itemArg["armingAuthorityAcronym"];

      this.$data.active = args.itemArg["isActive"];

      this.$data.updateDate = args.itemArg["updateDate"];
      if (this.$data.updateDate) {
        this.$data.updateDate = this.formatDateFnc(this.$data.updateDate);
      }

      this.$data.modalTitle = 'Edit Arming Authority Record';

      // console.log('this.$data.active = ', this.$data.active);

      let modalWindow = document.querySelector("#xmodal-main-ID");
      modalWindow.style.display = "block";

      let yesRadioButton = document.querySelector('#radioActiveID');
      let noRadioButton = document.querySelector('#radioInactiveID');

      if (this.$data.active == true) {
        yesRadioButton.checked = true;
        noRadioButton.checked = false;
      } else {
        yesRadioButton.checked = false;
        noRadioButton.checked = true;
      }

    },

    UpdateRecordActiveState(armingAuthorityId, armingAuthState) {

      // console.log('--------------->UpdateRecordActiveState<---------------------------');

      axios
        .get(store.webAPIUrl + "ArmingAuthority/UpdateArmingAuthActive/" + 
        this.UserProfileId + '/' +
        armingAuthorityId + '/' + 
        armingAuthState)
        .then((response) => response.data)
        .then(() => {
          this.getGridData();
        });
    },

    validateActiveState() {
      let yesRadioButton = document.querySelector('#radioActiveID');
      let noRadioButton = document.querySelector('#radioInactiveID');

      if ((yesRadioButton.checked == false) && (noRadioButton.checked == false)) {
        this.$data.validationErrorsFound = true;
        this.$data.activeNotSelected = true;
      }

    },

    validateNameNullOrUnique() {


      if (this.$data.acronym == null) {
        this.$data.acronymUndefined = true;
        this.$data.validationErrorsFound = true;
      } else if (this.$data.acronym.trim().length == 0) {
        this.$data.acronymUndefined = true;
        this.$data.validationErrorsFound = true;
      }

      if (this.$data.name == null) {
        this.$data.nameUndefined = true;
        this.$data.validationErrorsFound = true;
      } else if (this.$data.name.trim().length == 0) {
        this.$data.nameUndefined = true;
        this.$data.validationErrorsFound = true;
      } else {

        for (let i = 0; i < this.$data.gridOfNamesOnly.length; i++) {
          let name = this.$data.gridOfNamesOnly[i]['name'];
          let id = this.$data.gridOfNamesOnly[i]['id'];

          let trimmedOriginalName = name.trim().toLowerCase();
          let trimmedNewName = this.$data.name.trim().toLowerCase();

          if (this.$data.createSelected == false) {
            if ((trimmedOriginalName === trimmedNewName) && (this.$data.armingauth_ID != id)) {
              this.$data.nameNotUnique = true;
              this.$data.validationErrorsFound = true;
              break;
            }
          } else {
            if (trimmedOriginalName === trimmedNewName) {
              this.$data.nameNotUnique = true;
              this.$data.validationErrorsFound = true;
              break;
            }
          }

        }
      }

    },

    validateFields() {

      this.clearValidationFields();

      this.validateNameNullOrUnique();

      if (this.$data.createSelected == true) {
        this.validateActiveState();
      }
    },

  },
};
</script>

<style scoped>
/* ----------------- page ------------------------ */

.mainPageDiv {
  margin-top: 0px;
  margin-left: 0px;
  margin-bottom: 0px;
  padding-right: 0px;
  text-align: left;
  width: 100%;
}

.vertAlignMiddle {
  vertical-align: middle;
}

.radioButtonLeftMargin {
  margin-left: 10px;
}

.labelAlign {
  vertical-align: middle;
  padding: 0px;
  margin: 0px;
  padding-left: 5px;
}

/* -----------------  slots ------------------------ */

.activeAgency {
  margin-left: 20px;
  display: inline-block;
}

.activeInactiveString{
  display: inline-block; 
  width: 50px;
}

.spanLink {
  text-decoration: underline;
  cursor: pointer;
}

.editIconSlot {
  margin: 0px;
  font-size: 20px;
  margin-left: 10px;
  vertical-align: middle;
  cursor: pointer;
}

.actionsHeader {
  padding: 0px;
  margin: 0px;
  margin-left: 0px;
}

/* --------------- page header ----------- */

.subHeaderFont {
  font-size: 18px;
}

.pageHeader {
  font-size: 24px;
}

.forIconNewRecord {
  margin-left: 5px;
  cursor: pointer;
  font-size: 24px;
  vertical-align: middle;
}

.radioFirstLeftMargin {
  margin-left: 40px;
}

.radioOtherLeftMargin {
  margin-left: 20px;
}

.radioheaderadjustment {
  padding: 5px;
  margin-top: 5px;
  display: inline-block;
}

.lableMargin {
  margin-left: 5px;
}

/* -------------------------------------------------------------- */
/* ------------------- start modal style ------------------------ */
/* -------------------------------------------------------------- */

.cancelButton {
  background: #6d757c;
  color: white;
  border-radius: 6px;
  margin-left: 10px;
  cursor: pointer;
}
 
.cancelButton:Hover {
  background: #4e5257;
  color: white;
}


option:first-of-type {
  color: blue;
}

/* ---------- containers ---------- */

.headerMainContainer {
  display: grid;
  grid-template-rows: auto;
  grid-template-columns: 10% 80% 10%;
}

.cancelModalX {
  cursor: pointer;
}

.xmodal-container-main {
  display: none;
  /* Hidden by default */
  position: fixed;
  /* Stay in place */
  z-index: 1;
  /* Sit on top */
  padding-top: 50px;
  /* Location of the box */
  left: 0;
  top: 0;
  width: 100%;
  /* Full width */
  height: 100%;
  /* Full height */

  /* Enable scroll if needed */
  background-color: rgb(0, 0, 0);
  /* Fallback color */
  background-color: rgba(0, 0, 0, 0.4);
  /* Black w/ opacity */
}

.xmodal-container-form {
  margin: 5px;
  display: grid;
  grid-template-columns: 35% 65%;
  align-items: center;
  justify-content: center;

  /* background-color: lightyellow; */
}

.xmodal-container-content {
  background-color: #fefefe;
  margin: auto;

  padding: 20px;
  border: 1px inset black;

  width: 50%;
  height: 70%;

  min-height: 400px;
  max-height: 400px;
  
  min-width: 950px;
  max-width: 1000px;
  
  margin-bottom: 250px;
  overflow-x: auto;
}

/* ---------- header and footer ---------- */

.xmodal-title {
  text-align: left;
  margin-left: 10px;
  font-size: x-large;
}

.xmodal-footer {
  text-align: center;
}

/* ---------- buttons ---------- */

.xmodal-button-Radius {
  border-radius: 6px;
}

/* **** cancel btn */

.xmodal-cancelButton {
  cursor: pointer;
}

/* **** submit btn */

.xmodal-yesSubmitButton {
  margin-left: 10px;
  cursor: pointer;
}

.xmodal-yesSubmitButton:hover {
  background-color: rgb(19, 64, 0);
  color: white;
}

/* ---------- hr separators ---------- */

.xmodal-hr-top {
  margin-bottom: 20px;
  background-color: #E6E6E6;
}

.xmodal-hr-bottom {
  margin-top: 20px;
  margin-bottom: 20px;
  background-color: #E6E6E6;
}

/* ---------- validation ---------- */

.xmodal-outer-div {
  margin: 5px;
  display: grid;
  grid-template-columns: 80%;
  align-items: center;
  justify-content: center;
}

.xmodal-inner-div {
  margin: 0 auto;
}

.xmodal-li-validation {
  text-align: left;
  margin-top: 15px;
  color: black;
  width: 400px;
}

.xmodal-required-asterisk {
  margin-left: 2px;
  font-size: x-large;
}

/* ---------- content elements ---------- */

.xmodal-textbox-padding {
  padding: 5px;
}

.xmodal-control-labels {
  display: flex;
  align-items: center;
  font-weight: 400;
  color: rgb(2, 2, 175);
}

.xmodal-content-justify-right {
  display: flex;
  justify-content: right;
  padding-right: 10px;
}

.xmodal-content-justify-left {
  display: flex;
  justify-content: left;
  align-items: center;
}

/* --------------------------------------------- */
/* -------------- end Modal style -------------- */
/* --------------------------------------------- */
</style>
